/**
 * 콤마 추가
 * @param commaNumber
 */
export const addComma = (commaNumber) => {
    const isNumberRegex = /^[0-9]+$/;
    const replaceRegex = /(\d)(?=(\d{3})+(?!\d))/g;
    if (commaNumber === undefined
        || commaNumber === null) {
        return '';
    }
    if (typeof commaNumber === 'string') {
        // 숫자로만 이루어져있는지 체크
        if (isNumberRegex.test(commaNumber)) {
            // 문자열에 콤마 추가
            return commaNumber.replace(replaceRegex, '$1,');
        }
        return commaNumber;
    }
    return commaNumber.toLocaleString();
};
/**
 * 콤마 제거 + Number 타입으로 변경
 * @param commaNumber
 * @param numberTypeReturn
 * @returns
 */
export const deleteComma = (commaNumber, numberTypeReturn = false) => {
    const value = commaNumber.replace(/,/g, '');
    if (numberTypeReturn) {
        return Number(value);
    }
    return value;
};
